import axios from "axios";
import { STORAGE_KEY_AUTH_DATA, TOKEN_STORAGE_KEY } from "./common/constants";

const getBaseConfig = (isAuth, extraHeaders = {}, content = "application/json") => {
	const authHeader = isAuth
		? { Authorization: `Bearer ${localStorage.getItem(TOKEN_STORAGE_KEY)}` }
		: {};
	return {
		baseURL: "https://jorooms.com/api/v1/panel",
		timeout: 30000,
		headers: {
			Accept: "application/json",
			"Content-type": content,
			...authHeader,
			...extraHeaders,
		},
	};
};

const makeNetworkRequest = async (isAuth, url, method, body, headers = {}) => {
	const baseConfig = getBaseConfig(isAuth, headers);
	const config = {
		...baseConfig,
		url,
		method,
		data: body,
	};
	try {
		return await (
			await axios.request(config)
		).data;
	} catch (error) {
		//console.log("in makeNetworkRequest", error?.response);

		if (error.response.status === 401) {
			//detect unauthorized response

			window.localStorage.removeItem(STORAGE_KEY_AUTH_DATA);
			window.localStorage.removeItem(TOKEN_STORAGE_KEY);
			window.dispatchEvent(new Event("storage"));
		}

		return error?.response?.data ?? null;
	}
};

export const login = async (email, password) => {
	return await makeNetworkRequest(false, "/login", "POST", {
		email,
		password,
	});
};

// Properties
export const createProperty = async (data) => {
	return await makeNetworkRequest(true, "/properties", "POST", data);
};

export const updateProperty = async (id, data) => {
	return await makeNetworkRequest(true, "/properties/" + id, "PUT", data);
};

export const getAllProperties = async () => {
	return await makeNetworkRequest(true, "/properties", "GET");
};

export const updatePropertyStatus = async (id, data) => {
	return await makeNetworkRequest(true, "/properties/" + id + "/status", "PATCH", data);
};

export const uploadPropertyImages = async (id, imageData) => {
	console.log(imageData);
	let count = 0;
	for (const image of imageData) {
		let response = await makeNetworkRequest(
			true,
			"/properties/" + id + "/images",
			"POST",
			image
		);
		if (response?.success) count++;		
	}

	if (count === 0) {
		return {
			success: false,
			message: "Could not upload the images!",
		};
	}

	return {
		success: true,
		message: count + " images uploaded successfully!",
	};
};

export const deletePropertyImage = async (id, imageData) => {
	console.log(imageData);
	let count = 0;
	for (const image of imageData) {
		let response = await makeNetworkRequest(
			true,
			"/properties/" + id + "/images",
			"DELETE",
			image
		);
		if (response?.success) count++;		
	}

	if (count === 0) {
		return {
			success: false,
			message: "Could not delete the images",
		};
	}

	return {
		success: true,
		message: count + " images deleted successfully!",
	};
};

export const getSingleProperty = async (id) => {
	return await makeNetworkRequest(true, "/properties/" + id, "GET");
};

//Category
export const getAllCategories = async () => {
	return await makeNetworkRequest(true, "/categories", "GET");
};

export const createCategory = async (data) => {
	return await makeNetworkRequest(true, "/categories", "POST", data);
};

export const updateCategory = async (id, data) => {
	return await makeNetworkRequest(true, "/categories/" + id, "PUT", data);
};

//Tags
export const getAllTags = async () => {
	return await makeNetworkRequest(true, "/tags", "GET");
};

export const createTag = async (data) => {
	return await makeNetworkRequest(true, "/tags", "POST", data);
};

export const updateTag = async (id, data) => {
	return await makeNetworkRequest(true, "/tags/" + id, "PUT", data);
};

//Home Sections
export const getAllHomeSections = async () => {
	return await makeNetworkRequest(true, "/home_sections", "GET");
};

export const createNewHomeSection = async (data) => {
	return await makeNetworkRequest(true, "/home_sections", "POST", data);
};

export const updateSingleHomeSection = async (id, data) => {
	return await makeNetworkRequest(true, "/home_sections/" + id, "PUT", data);
};

export const deleteSingleHomeSection = async (id) => {
	return await makeNetworkRequest(true, "/home_sections/" + id, "DELETE");
};

//Property lite
export const getAllPropertyLite = async () => {
	return await makeNetworkRequest(true, "/properties/lite_index", "GET");
};

//Users

export const getAllUsersData = async () => {
	return await makeNetworkRequest(true, "/users", "GET");
};

export const createNewUser = async (data) => {
	return await makeNetworkRequest(true, "/users", "POST", data);
};

export const updateUserData = async (id, data) => {
	return await makeNetworkRequest(true, "/users/" + id + "/update", "PUT", data);
};

export const deleteUserData = async (id) => {
	return await makeNetworkRequest(true, "/users/" + id, "DELETE");
};

//Advertisement
export const getAllAdvertisementConfig = async () => {
	return await makeNetworkRequest(true, "/ads/config", "GET");
};

export const getAllAdvertisementsData = async () => {
	return await makeNetworkRequest(true, "/ads", "GET");
};

export const createAdvertisement = async (data) => {
	return await makeNetworkRequest(true, "/ads", "POST", data);
};

export const updateAdvertisement = async (id, data) => {
	return await makeNetworkRequest(true, "/ads/" + id + "/update", "POST", data);
};

export const deleteAdvertisement = async (id) => {
	return await makeNetworkRequest(true, "/ads/" + id, "DELETE");
};

//contact request
export const getAllContactRequest = async () => {
	return await makeNetworkRequest(true, "/contacts", "GET");
};

export const deleteContactRequest = async (id) => {
	return await makeNetworkRequest(true, "/contacts/" + id, "DELETE");
};

//Search score
export const getAllSearchScore = async () => {
	return await makeNetworkRequest(true, "/properties/search_index", "GET");
};

export const updateSearchScore = async (id, data) => {
	return await makeNetworkRequest(true, "/properties/" + id + "/search_index", "POST", data);
};

//Image Resources
export const getAllImageResources = async () => {
	return await makeNetworkRequest(true, "/resources/image?subtype=main_slide", "GET");
};

export const createImageResource = async (data) => {
	return await makeNetworkRequest(true, "/resources/image", "POST", data);
};

export const deleteImageResource = async (id) => {
	return await makeNetworkRequest(true, `/resources/${id}/image`, "DELETE");
};
